import { CSSProperties, useEffect, useRef, useState } from 'react';

type IFrameProps = {
  src: string;
  title?: string;
  targetRootId?: string;
  style?: CSSProperties;
  messageToSend?: any;
};

export const IFrame = ({ src, title, targetRootId = 'root', style, messageToSend }: IFrameProps) => {
  const [height, setHeight] = useState(300);
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const resizeObserverRef = useRef<ResizeObserver | null>(null);

  useEffect(() => {
    if (messageToSend && iframeRef.current) {
      iframeRef.current.contentWindow?.postMessage(messageToSend, '*'); // '*' allows cross-origin communication, adjust as needed
    }
  }, [iframeRef, messageToSend]);

  useEffect(() => {
    return () => resizeObserverRef.current?.disconnect();
  }, []);

  return (
    <iframe
      src={src}
      title={title}
      ref={iframeRef}
      height={height}
      style={style}
      onLoad={() => {
        const contentWindow = iframeRef.current?.contentWindow;
        if (!contentWindow) return;
        const iframeApp = contentWindow.document.body.querySelector(`#${targetRootId}`);
        if (!iframeApp) return;
        if (!resizeObserverRef.current) {
          resizeObserverRef.current = new ResizeObserver((entries) => {
            entries.forEach((entry) => {
              setHeight(entry.contentRect.height);
            });
          });
        } else {
          resizeObserverRef.current.disconnect();
        }
        // observe any size changes and update the iframe height
        resizeObserverRef.current.observe(iframeApp);
      }}
    />
  );
};
